import React from "react";
import { EmptyState } from "../HearingBundles/steps/Step2pickpages";
import styled from "styled-components";

const CaseDiscovery = () => {
  return (
    <Container>
      <Content>
        <TabBody>
          <EmptyState
            style={{
              fontSize: "18px",
              fontFamily: "openSans-SemiBold, sans-serif",
            }}
          >
            Coming Soon
          </EmptyState>
        </TabBody>
      </Content>
    </Container>
  );
};

export default CaseDiscovery;

export const Container = styled.div`
  width: 100%;
  padding: 12px 0;

  @media (max-width: 768px) {
    padding: 8px 0;
  }
`;

export const Content = styled.div`
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
`;

export const TabBody = styled.div`
  padding: 16px;

  @media (max-width: 768px) {
    padding: 12px;
  }
`;
